import { EPaymentMethod } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { Route } from "react-router-dom";
import { BankWireOverview } from "./routes/BankWireOverview";
import { MangopayAddIban } from "./routes/MangopayAddIban";
import { MangopayOverview } from "./routes/MangopayOverview";
import { PaymentLimit } from "./routes/PaymentLimit";
import { PaymentMethodSelect } from "./routes/PaymentMethodSelect";
import { PaymentOverview } from "./routes/PaymentOverview";
import { PaymentStatus } from "./routes/PaymentStatus";

export const getPaymentScene = () => {
  return (
    <Route path="payment/:paymentRequestId">
      <Route path={"payment-method"} element={<PaymentMethodSelect />} />

      <Route path={"payment-method/mangopay"} element={<MangopayOverview />} />

      <Route
        path={"payment-method/mangopay/add-iban"}
        element={<MangopayAddIban />}
      />

      <Route
        path={"payment-method/bank-wire"}
        element={<BankWireOverview paymentMethod={EPaymentMethod.BankWire} />}
      />

      <Route
        path={"payment-method/ibanisation"}
        element={
          <BankWireOverview paymentMethod={EPaymentMethod.Ibanisation} />
        }
      />

      <Route
        path={"payment-method/:paymentMethod/payment-limit"}
        element={<PaymentLimit />}
      />

      <Route path={"status"} element={<PaymentStatus />} />

      <Route index element={<PaymentOverview />} />
    </Route>
  );
};
